module.exports = __webpack_public_path__ + "img/bg-gc-common.e6a16808.png";